import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HeadMenu from './HeadMenu';
import HeroBanner from './HeroBanner';
import ReasonsWhy from './ReasonsWhy';
import KnowMoreBanner from './KnowMoreBanner';
import ProfessionalMarketing from './ProfessionalMarketing';
import CustomerReviewCarousel from './CustomerReviewCarousel';
import ContactFilter from './ContactFilter';
import { QuoteBanner, QuoteBannerTwo } from './QuoteBanner';
import ValuationAndArea from './ValuationAndArea';
import FAQ from './FAQ';
import Footer from './Footer';
import ThankYouPage1 from './ThankYouPage1';
import ThankYouPage2 from './ThankYouPage2';
import ThankYouPage3 from './ThankYouPage3';
import ThankYouPage4 from './ThankYouPage4';
import './App.scss';
import ReviewDisplay from './Review';
import PropertyDetails from './OnlineValuation/PropertyDetails';
import ValuationPage from './OnlineValuation/ValuationPage';
import Valuation2 from './OnlineValuation/ValuationPage2';
import LoadingPage from './OnlineValuation/LoadingPage';
import PrivacyPolicy from './PrivacyPolicy';
import TermsAndConditions from './TermsAndConditions';
import CallbackThankYou from './OnlineValuation/CallbackThankYou';
import TestComponent from './OnlineValuation/TestComponent';
import InPersonPropDetails from './OnlineBookingValInPerson/InPersonPropDetails';




const App = () => {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route 
            path="/" 
            element={
              <>
                <HeadMenu contactSectionId="contact-filter" />
                <HeroBanner />
                
                <ReasonsWhy />
                <ReviewDisplay />
                <KnowMoreBanner contactSectionId="contact-filter" />
                <ValuationAndArea />
                <QuoteBanner />
                <CustomerReviewCarousel />
                <FAQ />
                <KnowMoreBanner contactSectionId="contact-filter" />

                <ProfessionalMarketing />
                
                <QuoteBannerTwo />
                {/* <AllPlatformMarketing /> */}

                <ContactFilter id="contact-filter" />
                <Footer />
              </>
            } 
          />

<Route 
            path="/agent" 
            element={
              <>
                <HeadMenu contactSectionId="contact-filter" />
                <HeroBanner />
                
                <ReasonsWhy />
                <ReviewDisplay />
                <KnowMoreBanner contactSectionId="contact-filter" />
                <ValuationAndArea />
                <QuoteBanner />
                <CustomerReviewCarousel />
                <FAQ />
                <KnowMoreBanner contactSectionId="contact-filter" />

                <ProfessionalMarketing />
                
                <QuoteBannerTwo />
                {/* <AllPlatformMarketing /> */}

                <ContactFilter id="contact-filter" />
                <Footer />
              </>
            } 
          />

          <Route path="/thank-you-1" element={<ThankYouPage1 />} />
          <Route path="/thank-you-2" element={<ThankYouPage2 />} />
          <Route path="/thank-you-3" element={<ThankYouPage3 />} />
          <Route path="/thank-you-4" element={<ThankYouPage4 />} />
          <Route path="/:action/:userId" element={<CallbackThankYou />} />

          <Route path="/property_details" element={<PropertyDetails />} />
          <Route path="/valuation" element={<ValuationPage />} />
          <Route path="/valuation2" element={<Valuation2 />} /> 
          <Route path="/loading" element={<LoadingPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsAndConditions />} />

          <Route path="/thank-you-test" element={<TestComponent />} />


          {/* Version 2 - For In Person Bookings */}
          <Route path="/agent/valuation" element={<InPersonPropDetails />} />

        </Routes>
      </div>
    </Router>
  );
};

export default App;
